import { AxiosRequestConfig } from 'axios';

import Client from './client';

type Data = {
  device: string; // Device name, such as: iPhone 6, Google nexus 7 ...
  deviceId: string; // Unique device id of user;
  os: string; // OS of user device
  identity: string;
  password: string;
  region?: string;
};

type Response = {
  readonly result: 'SUCCESS' | 'FAIL';
  readonly status: number;
  readonly message: string;
  readonly userId: string; // unique id if user
  readonly refreshToken: string; //refresh token
  readonly region: string;
  readonly hasPhoneNumber: boolean; //determines if user has a phone number
  readonly setupComplete: boolean; //determines is user has entered username and password
  readonly admin: boolean; //determines if user is an admin
};

export default (data: Data, config?: AxiosRequestConfig) => {
  return Client.post<Response>('/auth/v1/login', data, config);
};
